import React, { useEffect, useState } from 'react'
import { GetById_ObjectType_Api } from '../../API/objectTypeApi';
import { AllFieldComponent } from './AllFieldComponent';
import { Button, Col, Row } from 'antd';
import { AddFieldComponent } from './AddFieldComponent';
import { EditFieldComponent } from './EditFieldComponent';
import { addButton } from '../../assets/styles/stylesMain';
// =================================================================
export const FieldComponent = ({ objectTypeId, setLoading, showMessage, onBackClick }) => {
    // =================================================================
    const [view, setView] = useState('All');
    const [objectType, setObjectType] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [version, setVersion] = useState(0);
    const [fieldId, setFieldId] = useState(0);
    // =================================================================
    useEffect(() => {
        loadObjectType();
    }, [objectTypeId]);
    // =================================================================
    const loadObjectType = async () => {
        setLoading(true);
        try {
            const data = await GetById_ObjectType_Api(objectTypeId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setObjectType(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    return (
        <>
            {
                view === "All" ?
                    <AllFieldComponent
                        objectTypeId={objectTypeId}
                        objectTypeTitle={objectType?.title}
                        setLoading={setLoading}
                        showMessage={showMessage}
                        version={version}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        onAddClick={() => setView("Add")}
                        onEdit={(id) => { setFieldId(id); setView("Edit"); }}
                        onRowDeleted={() => { setVersion(version + 1); }}
                        onBackClick={onBackClick} /> : <></>
            }
            {
                view === "Add" ?
                    <AddFieldComponent
                        objectTypeId={objectTypeId}
                        setLoading={setLoading}
                        showMessage={showMessage}
                        rowInserted={() => {
                            setView("All"); if (currentPage != 1)
                                setCurrentPage(1);
                            else
                                setVersion(version + 1);
                        }}
                        cancelInsert={() => { setView("All"); }} /> : <></>
            }
            {
                view === "Edit" ?
                    <EditFieldComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        id={fieldId}
                        objectTypeId={objectTypeId}
                        rowUpdated={() => { setView("All"); setVersion(version + 1); }}
                        cancelEdit={() => { setView("All"); }} />
                    : <></>
            }
        </>
    )
}
